import { render, staticRenderFns } from "./AllNewsView.vue?vue&type=template&id=06c1669e&scoped=true&"
import script from "./AllNewsView.vue?vue&type=script&lang=js&"
export * from "./AllNewsView.vue?vue&type=script&lang=js&"
import style0 from "./AllNewsView.vue?vue&type=style&index=0&id=06c1669e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c1669e",
  null
  
)

export default component.exports